module.exports = __webpack_public_path__ + "img/70.8c14a142.jpg";